<header class="header-mobile" [ngClass]="{ welcome: isWelcome() }">
  <div class="header-mobile__wrapper">
    <div class="header-mobile__left">
      <div class="header-mobile__toggle" (click)="onMobileMenuClick()">
        <img
          src="assets/img/icons/hamburger.svg"
          [ngClass]="{ 'white-overlay': isWelcome() }"
          [alt]="'HEADER.open_menu' | translate"
        />
      </div>
      <a
        *ngIf="!ukraineUrl"
        class="header-mobile__search"
        [routerLink]="['/' + RoutesPath.default.verified]"
        (click)="setAutoFocus(true)"
        (clickOutside)="removeAutofocus()"
      >
        <img src="assets/img/icons/search.svg" [alt]="'HEADER.LINKS.search' | translate" />
      </a>
    </div>
    <div class="header-mobile__center">
      <a class="header-mobile__link" [routerLink]="headerLink">
        <img
          class="header-mobile__brand"
          [ngClass]="{ 'white-overlay': isWelcome() }"
          [src]="logoSrc"
          [alt]="'GLOBAL.app_name' | translate"
        />
      </a>
    </div>
    <app-lang-switcher></app-lang-switcher>
  </div>
  <aside class="sidebar" #sidebar [ngClass]="{ 'with-transform': !isWelcome() }">
    <div class="sidebar__header" *ngIf="!storage.user">
      <!--      <a class="btn btn&#45;&#45;primary btn&#45;&#45;md"-->
      <!--         [routerLink]="[]"-->
      <!--         [queryParams]="authPage('register')"-->
      <!--         (click)="closeMobileMenu()">{{ "AUTH.sign_up" | translate }}</a>-->
      <a
        class="btn btn--link btn--lg btn--dark btn--log-in"
        [routerLink]="[]"
        [queryParams]="authPage('login')"
        (click)="closeMobileMenu()"
        >{{ 'AUTH.sign_in' | translate }}</a
      >

      <ng-container *ngIf="ukraineUrl">
        <a
          class="btn btn--primary btn--sm btn--primary--full-width"
          [routerLink]="[]"
          [queryParams]="authPage('login')"
          >{{ 'HELPUKRAINE_PAGE.help_ukraine' | translate }}</a
        >
      </ng-container>
    </div>
    <div class="sidebar__header" *ngIf="storage.user">
      <ng-container *ngIf="ukraineUrl">
        <a
          class="btn btn--outline btn--primary btn--md"
          [routerLink]="['/help-ukraine-request/create']"
          (click)="closeMobileMenu()"
          >{{ 'HEADER.LINKS.create_ua_help' | translate }}</a
        >
      </ng-container>

      <ng-container *ngIf="!ukraineUrl">
        <a
          class="btn btn--outline btn--primary btn--md"
          [routerLink]="['/' + RoutesPath.default.event_create]"
          (click)="closeMobileMenu()"
          >{{ 'HEADER.LINKS.create_event' | translate }}</a
        >
        <a
          class="btn btn--outline btn--primary btn--md"
          [routerLink]="['/' + RoutesPath.default.project_create]"
          (click)="closeMobileMenu()"
          >{{ 'HEADER.LINKS.create_project' | translate }}</a
        >
      </ng-container>
    </div>
    <div class="sidebar__separator"></div>
    <div class="sidebar__account" *ngIf="storage.user">
      <div class="sidebar__avatar-toggle" (click)="onSidebarAccountMenuClick()">
        <app-ph-avatar
          [username]="
            storage.user.sign_project_by_name
              ? storage.setAvatarInitials(storage.user.display_name, '')
              : storage.setAvatarInitials(storage.user.name, storage.user.surname)
          "
          [src]="storage.user.avatar_image"
        ></app-ph-avatar>
        <div class="sidebar__account-wrapper">
          <span class="sidebar__account-name">{{ 'HEADER.my_account' | translate }}</span>
          <div class="sidebar__account-chevron" [ngClass]="{ is__open: isSidebarAccountMenuOpen }">
            <img src="assets/img/icons/chevron.svg" [alt]="'HEADER.open_user_menu' | translate" />
          </div>
        </div>
      </div>
      <ul class="list list--sidebar list--sidebar-account" *ngIf="isSidebarAccountMenuOpen">
        <li class="list__item">
          <a
            class="list__link"
            [routerLink]="[
              '/' +
                RoutesPath.default.profile +
                '/' +
                storage.user.id +
                '/' +
                RoutesPath.default.profileTabs.summary
            ]"
            (click)="closeMobileMenu()"
            >{{ 'HEADER.LINKS.my_profile' | translate }}</a
          >
        </li>
        <li class="list__item">
          <a
            class="list__link"
            [routerLink]="['/' + RoutesPath.default.wallet]"
            (click)="closeMobileMenu()"
            >{{ 'HEADER.LINKS.wallet' | translate }}</a
          >
        </li>
        <li class="list__item">
          <a
            class="list__link"
            [routerLink]="['/' + RoutesPath.default.account]"
            (click)="closeMobileMenu()"
            >{{ 'HEADER.LINKS.account_settings' | translate }}</a
          >
        </li>
        <li class="list__item">
          <a class="list__link text--danger" (click)="storage.logout()">{{
            'AUTH.sign_out' | translate
          }}</a>
        </li>
      </ul>
      <div class="sidebar__separator"></div>
    </div>
    <div class="sidebar__nav">
      <ul class="list list--sidebar">
        <li class="list__item" *ngFor="let menuItem of menuItems">
          <a
            *ngIf="menuItem.routerLink; else externalLink"
            class="list__link"
            [routerLink]="menuItem.routerLink"
            [ngClass]="{ is__active: isActive(menuItem.routerLink) }"
            (click)="closeMobileMenu()"
            >{{ menuItem.title | translate }}</a
          >
          <ng-template #externalLink>
            <a
              class="list__link"
              [href]="menuItem.outgoingLink"
              [ngClass]="{ is__active: isActive(menuItem.routerLink) }"
              (click)="closeMobileMenu()"
              target="_blank"
              >{{ menuItem.title | translate }}</a
            >
          </ng-template>
        </li>
        <li class="list__item" *ngIf="storage.user">
          <button class="btn btn--link list__link btn--notifications" (click)="openNotifications()">
            {{ 'HEADER.LINKS.notifications' | translate }}
            <span class="header__items" *ngIf="notificationsUnseen > 0">{{
              notificationsUnseen
            }}</span>
          </button>
        </li>
        <li class="list__item">
          <div class="header-mobile__socials">
            <div class="header-mobile__socials__wrapper">
              <div class="header-mobile__socials--single">
                <a target="_blank" [href]="facebookLink">
                  <img src="assets/img/icons/facebook-color.webp" alt="Facebook" />
                </a>
              </div>
              <div class="header-mobile__socials--single">
                <a target="_blank" [href]="instagramLink">
                  <img src="assets/img/icons/instagram-logo-color.webp" alt="Instagram" />
                </a>
              </div>
            </div>
          </div>
        </li>
      </ul>
    </div>
  </aside>
  <app-notifications-dropdown
    (closeNotificationEmitter)="closeNotificationsMobile()"
    *ngIf="notificationOpen"
  ></app-notifications-dropdown>
</header>
